import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const AlertModal = ({ show, handleClose, msg, onRetry }) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{msg.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{msg.message}</Modal.Body>
            <Modal.Footer>
                {onRetry && (
                    <Button variant="success" onClick={onRetry}>
                        Recarregar
                    </Button>
                )}
                <Button variant="secondary" onClick={handleClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default AlertModal;